import { render, staticRenderFns } from "./informations.vue?vue&type=template&id=07036e62"
import script from "./informations.vue?vue&type=script&lang=js"
export * from "./informations.vue?vue&type=script&lang=js"
import style0 from "./informations.vue?vue&type=style&index=0&id=07036e62&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports